import {
  keyArgsForPagination,
  mergeForPagination,
  mergeForPaginationWithUnitPlans,
} from "./modules/utils";

const LearningCoursePolicy = {
  LearningCourse: {
    fields: {
      unitPlans: {
        keyArgs: args => {
          if (args) {
            const keys = keyArgsForPagination(args);
            return [keys];
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPaginationWithUnitPlans({
              existing,
              incoming,
              readField,
              filters: args,
            });
          }
          return incoming;
        },
      },
      applicableChildCourses: {
        keyArgs: args => {
          if (args) {
            const keys = keyArgsForPagination(args);
            return keys;
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPagination({
              existing,
              incoming,
              readField,
              filters: args,
            });
          }
          return incoming;
        },
      },
      collaborators: {
        keyArgs: args => {
          if (args) {
            const keys = keyArgsForPagination(args);
            return keys;
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          if (args) {
            return mergeForPagination({
              existing,
              incoming,
              readField,
              filters: args,
            });
          }
          return incoming;
        },
      },
      learningCourseSyncHistory: {
        keyArgs: args => {
          if (args) {
            return keyArgsForPagination(args);
          }
        },
        merge: (existing = {}, incoming = {}, { readField, args }) => {
          return mergeForPagination({
            existing,
            incoming,
            readField,
            filters: args,
          });
        },
      },
    },
  },
};

export default LearningCoursePolicy;
